import { useEffect } from 'react';

interface Props {
  isBottom?: boolean;
  curWeekBarRef: React.MutableRefObject<HTMLDivElement | null>;
  calendarWrapperRef: React.MutableRefObject<HTMLDivElement | null>;
  activeTileClass: string;
}

export default function useHandleWeekSelBar({
  activeTileClass,
  curWeekBarRef,
  calendarWrapperRef,
}: Props) {
  useEffect(() => {
    if (!curWeekBarRef || !calendarWrapperRef) {
      console.error('No curWeekBarRef or calendarWrapperRef');
      return;
    }

    const curWeekBar = curWeekBarRef.current;
    const calendarWrapper = calendarWrapperRef.current;
    const curActiveTile =
      calendarWrapper?.querySelector<HTMLDivElement>(activeTileClass);

    if (!calendarWrapper || !curWeekBar || !curActiveTile) {
      // console.error('No calendarWrapper or curWeekBar or curActiveTile');
      return;
    }

    const tileY = curActiveTile ? curActiveTile?.offsetTop : 0;

    // todo revise, how to avoid -1;
    curWeekBar.style.top = `${tileY - 1}px`;
  });
}
